import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { apiUrls, apiHostUrl, unauth } from '../../shared/utils/globalConfig';
import { addHeaders } from '../../shared/utils/globalUtils';

export const traveldatesApi = createApi({
    reducerPath: 'traveldates',
    baseQuery: fetchBaseQuery({
        baseUrl: apiHostUrl,
        prepareHeaders: (headers) => {
            return addHeaders(headers, unauth);
        }
        
    }),
  
    endpoints: (builder) => ({
        getTravelDatesByName: builder.query({
            query: (payload) => {
                return {
                url: unauth ? apiUrls?.itpNsaTravelDatesUrl_ua : apiUrls?.itpNsaTravelDatesUrl,
                method: 'POST',
                body: payload
            }
            }
        }),
    }),

})

export const { useGetTravelDatesByNameQuery } = traveldatesApi;